/**
 * v3.91.0 — a trusted-computer answer that landed after its 15-second limit.
 *
 * By then the code screen has taken over, and the user may have cancelled,
 * signed in again (with this or another account) or signed out. Firebase has
 * already made the late sign-in the session, so App must decide whether to
 * keep it:
 *
 *  - sign it out when, at the moment it lands, the app is showing another
 *    account (e.g. one signed in from another tab) — a global-administrator
 *    session must never replace someone else's;
 *  - keep, when its own code screen is still the current attempt (nothing
 *    cancelled, nobody signed out since) — the code screen then closes;
 *  - keep, when a newer sign-in in this tab completed for the SAME account —
 *    the late one only replaced an equivalent session;
 *  - otherwise sign it out (a cancelled sign-in must not come back).
 *
 * App re-checks at the moment of signing out that the late sign-in is still
 * the session (a newer sign-in may have replaced it meanwhile).
 */
export function lateAnswerDecision({ attempt, currentAttempt, signedInAttempt, signedInUid, lateUid, appUid = null }) {
  if (appUid && appUid !== lateUid) return 'sign-out';
  if (attempt === currentAttempt) return 'keep';
  if (signedInAttempt > attempt && !!signedInUid && signedInUid === lateUid) return 'keep';
  return 'sign-out';
}
